import {
  HistoryVoucher,
  StatsHistoryVoucher,
} from "@/components/historyvoucher";
import { HistoryVoucherType } from "@/types";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslate } from "react-admin";

type CashierDashboardProps = {
  historyVoucher: HistoryVoucherType[];
};

const CashierDashboard = ({ historyVoucher }: CashierDashboardProps) => {
  const translate = useTranslate();
  return (
    <Box>
      <Grid size={12}>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
          {translate("ra.gameoo.statsVoucherLabel")}
        </Typography>
      </Grid>
      <Grid container spacing={3} mt={5}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <HistoryVoucher data={historyVoucher} />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <StatsHistoryVoucher history={historyVoucher} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CashierDashboard;
